<template>
  <v-container
      fluid
  >
    <v-row>
      <v-spacer></v-spacer>
      <v-col
          cols="12"
          xs="12"
          sm="12"
          md="12"
          lg="12"
          xl="12"
      >
        <v-carousel
            v-model="model"
            cycle
            :height="carouselHeight"
            :hide-delimiters="carouselHeight < 400"
        >
          <v-carousel-item
              v-for="(item, index) in items"
              :key="index"
              :src="item.src"
              transition="fade-transition"
          >
            <v-overlay value="true" absolute>
              <v-row
                  class="fill-height white--text"
                  align="center"
                  justify="center"
              >
                <div
                  v-if="carouselHeight >= 200"
                  class="text-h2">
                  {{ item.text }}
                  <v-spacer></v-spacer>
                  <v-btn
                      x-large
                      class="primary white--text"
                      outlined
                      :to="item.link"
                  >
                    Hier klicken
                  </v-btn>
                </div>
              </v-row>
            </v-overlay>
          </v-carousel-item>
        </v-carousel>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-row>
      <v-col
        cols="12"
      >
        <!---
        <v-alert
          class="ma-0"
          type="error"
        >
          Wetterbedingt fällt das Training am Montag den 12.01. aus. Die Turnhallen sind gesperrt.
        </v-alert>
        --->
        <!---
        <v-alert
          class="ma-0"
          type="warning"
        >
          Hallo Welt!
        </v-alert>
        --->
      </v-col>
    </v-row>
    <v-row
    >
      <v-spacer></v-spacer>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="6"
        lg="4"
        xl="3"
      >
        <v-card>
          <v-card-title>
            <v-icon
              class="mt-1"
            >
              mdi-bell
            </v-icon>
            Neuigkeiten
          </v-card-title>
          <v-card-text>
            Wir freuen uns, Wiebke als unsere neue Schriftführerin begrüßen zu dürfen – herzlich willkommen im Team!
            Außerdem übernimmt Emre künftig das Amt des Sportwartes. Vielen Dank für dein Engagement!
          </v-card-text>
        </v-card>
        <!---
        <v-card
          class="ml-2 mt-1"
        >
          <v-card-title>
            <v-icon
              class="mt-1"
            >
              mdi-bell
            </v-icon>
            Neuigkeiten
          </v-card-title>
          <v-card-text>
            Testtext zur Erinnerung, welcher für eine kurzen Hinweis auf der HP ist. ab                 ## spitzeklammer ausrufezeichen bis nach V-card
          </v-card-text>
        </v-card>
        --->
      </v-col>
      <v-col
          cols="12"
          xs="12"
          sm="12"
          md="6"
          lg="4"
          xl="4"
      >
        <v-img
          src="spkasse.png"
          @click="openLink('https://www.fahrgastfernsehen.city/beitrag/5669381-sparkassen-sportfonds-verteilt-200-000-euro-viel-geld-fuer-gute-vereinsarbeit')"
        >
        </v-img>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-row class="mt-6">
      <v-col
          v-for="(s, i) in $store.state.socials"
          :key="i"
          cols="12"
          sm="6"
          md="4"
      >
        <v-card
            class="social-card white--text"
            :class="s.gradient"
            hover
            :elevation="6"
        >
          <v-card-text class="py-4 px-5">
            <div class="d-flex align-center mb-2">
              <v-icon medium class="mr-2 white--text">{{ s.icon }}</v-icon>
              <div>
                <div class="subtitle-1 font-weight-bold">{{ s.name }}</div>
                <div class="caption white--text text--lighten-4">{{ s.handle }}</div>
              </div>
            </div>

            <div
                class="caption mb-3"
                :style="{ color: s.gradient.includes('bg-tiktok') ? '#fff' : '#222', textShadow: '0 1px 3px rgba(0,0,0,0.6)' }"
            >
              {{ s.tagline }}
            </div>

            <v-btn
                :href="s.url"
                target="_blank"
                rel="noopener"
                small
                outlined
                class="white--text"
                block
            >
              <v-icon left small>{{ s.icon }}</v-icon>
              {{ s.cta }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
export default {
  name: "Home",
  data: () => ({
    model: 0,
    items: [
      { src: "Neuigkeiten1.jpg", text: "Aktueller Trainingsplan", link: "/trainingsplan" },
      { src: "Header1.jpg", text: "Neuer Sportwart", link: "/vorstand" }
    ],
  }),
  methods: {
    openLink(link) {
      window.open(link);
    }
  },
  computed: {
    carouselHeight () {
      const bp = this.$vuetify.breakpoint
      if (bp.xs) return 100
      if (bp.sm) return 150
      if (bp.md) return 200
      return 200
    }
  }
}
</script>
<style scoped>
.social-card {
  border-radius: 16px;
  transition: transform .15s ease, box-shadow .15s ease;
  min-height: 160px; /* angenehm kompakt */
}
.social-card:hover {
  transform: translateY(-1px);
}

.bg-instagram {
  background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fd5949 45%, #d6249f 60%, #285AEB 90%);
}
.bg-facebook {
  background: linear-gradient(135deg, #1877f2 0%, #0e5dc1 100%);
}
.bg-tiktok {
  background:
      radial-gradient(70% 100% at 15% 15%, rgba(0,255,255,.6), rgba(0,255,255,0) 60%),
      radial-gradient(70% 100% at 85% 85%, rgba(255,0,80,.6), rgba(255,0,80,0) 60%),
      linear-gradient(135deg, #111 0%, #222 100%);
}
</style>
